import React, { ReactElement } from 'react';

import { Endpoint, getFilterDates, ReportService } from '@philips-emr/hpms-stipulator-commons';
import { HPMSOnRenderAction } from '@philips-emr/hpms-stipulator-components/lib/events/event';
import { Button, FilterAPI } from '@philips-emr/tws-components';
import { ButtonTheme, Placement } from '@philips-emr/tws-constants';
import Controller, { OnDynamicContentRender, OnMount } from '@philips-emr/tws-core/lib/client';
import { MountEvent, RenderEvent } from '@philips-emr/tws-core/lib/component/types';

import { FaturasAliases as Aliases, FragmentNames } from '../../codegen';

import BaseFaturaCustomCardController, { Fatura } from './base-fatura-custom-card-controller';

@Controller({ fragment: FragmentNames.FATURAS })
export default class FaturasController extends BaseFaturaCustomCardController {

  private reportService: ReportService;

  @OnMount(Aliases.FILTER_FATURAS)
  public onMountFilter(event: MountEvent): void {
    const api = event.target as FilterAPI;

    api.setData(getFilterDates('dtInicio', 'dtFim', 12));
  }

  @OnMount(Aliases.FILTERED_LIST)
  public onMountFetchFaturas(): void {
    super.onMountFetchFaturas();
  }

  @OnDynamicContentRender(Aliases.HPMS_DYNAMIC_CONTENT_FIELD_SITUACAO)
  public onDynamicContentRenderCardLote(event: RenderEvent): void {
    super.onDynamicContentRenderCardLote(event);
  }

  @HPMSOnRenderAction(Aliases.HPMS_CUSTOM_CARD)
  onDynamicContentRenderCard(event: RenderEvent): void {
    this.renderButtonPrint(event);
  }

  private renderButtonPrint({ data, render }: RenderEvent): void {
    const { nrSeqFatura } = data as unknown as Fatura;

    const content = (): ReactElement => (
      <Button
        key="print"
        icon="/static/assets/hpms-print-gray.svg"
        theme={ButtonTheme.QUIET_EMPHASIS}
        value=""
        iconPlacement={Placement.LEFT}
        onClick={() => this.onClickPrint(nrSeqFatura)}
      />
    );
    
    render(content);
  }

  private onClickPrint(nrSeqFatura: number): void {
    const { nrSeqContrato } = this.historyService.getCurrentRouteParams();

    const requestParams = { nrSeqFatura, nrSeqContrato };
    const relatorioParams = { NR_SEQ_FATURA: nrSeqFatura, NR_SEQ_CONTRATO: nrSeqContrato };

    this.reportService = new ReportService('30', Endpoint.GET.FATURAS_RELATORIOS);
    this.reportService.abreListaRelatorios(relatorioParams, requestParams);
  }

}

